import React from 'react';
import {
  Box, Card, CardContent, CardHeader, TextField, MenuItem, Typography, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useLanguage } from '../context/LanguageContext';

const LanguageModal = ({ open, onClose }) => {
  const { currentLanguage, changeLanguage, t } = useLanguage();

  // Supported languages with codes and names
  const supportedLanguages = [
    { code: "en", name: "English", direction: "ltr" },
    { code: "my", name: "Burmese", direction: "ltr" },
    { code: "fr", name: "French", direction: "ltr" },
    { code: "kar", name: "Karen", direction: "ltr" },
    { code: "sw", name: "Swahili", direction: "ltr" },
  ];

  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1300
      }}
      onClick={onClose} // Close when clicking outside
    >
      <Card
        sx={{
          width: 400,
          maxWidth: '90%',
          position: 'relative' // For positioning the close button
        }}
        onClick={(e) => e.stopPropagation()} // Prevent click propagation inside card
      >
        {/* Close button */}
        <IconButton
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            zIndex: 2,
            color: '#fff'
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>

        <CardHeader
          title={t('selectLanguage')}
          sx={{
            backgroundColor: '#E27A58',
            color: '#fff',
            pr: 6 // Add padding to prevent title overlapping with close button
          }}
        />
        <CardContent>
          <Typography variant="body1" sx={{ mb: 3 }}>
            {t('chooseLanguage')}
          </Typography>
          <TextField
            select
            fullWidth
            value={currentLanguage}
            onChange={(e) => {
              changeLanguage(e.target.value);
              onClose();
            }}
            label={t('language')}
          >
            {supportedLanguages.map((lang) => (
              <MenuItem key={lang.code} value={lang.code}>
                {lang.name}
              </MenuItem>
            ))}
          </TextField>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LanguageModal;
